/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import store from './store'
import {sync} from 'vuex-router-sync'
import axios from 'axios'
import "./plugins/bootstrap";
import "./assets/css/main.css";
import './registerServiceWorker'
import {VUE_APP_APIPATH, VUE_APP_HOST} from './util/globals'

import GlobalTagItemType from './enum/elements';

Vue.prototype.$tagItemType = GlobalTagItemType;

Vue.config.productionTip = false;
Vue.use(Argon);

Vue.prototype.$url = VUE_APP_APIPATH
Vue.prototype.$host = VUE_APP_HOST
Vue.prototype.$http = axios
Vue.prototype.$baseUrl = process.env.BASE_URL

sync(store, router)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
